
var firebaseConfig = {
    apiKey: "AIzaSyCFVjxpKcUbbutN2kc8FYjrmqSLvxBXe-g",
    authDomain: "to-do-list-84ef2.firebaseapp.com",
    databaseURL: "https://to-do-list-84ef2.firebaseio.com",
    projectId: "to-do-list-84ef2",
    storageBucket: "to-do-list-84ef2.appspot.com",
    messagingSenderId: "910841674524",
    appId: "1:910841674524:web:3afecdcdea7160132918d9",
    measurementId: "G-Q9X2VGK61H"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

